import React from 'react';

import Row from './row';
import './main.less';

const Table = props => {

	const { table, intl, showMoreRows, topOffersCheckboxes }  = props;

	return (
		<div className="table-container top-offers-table">
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr>
						{
							table.headers
								.map((header, i) =>
									<th key={i} className={header.className || ''}>{intl(header.title)}</th>
								)
						}
						{
							table.hasViewAllPermission && <th>{intl('Leads')}</th>
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						<Row
							key={i}
							row={row}
							topOffersCheckboxes={topOffersCheckboxes}
							hasViewAllPermission={table.hasViewAllPermission}
						/>
					)}
				</tbody>
			</table>
			<p className="flex-center">
				{table.rows_count > table.rows.length && (
					<button
						className="ui-btn ui-btn-secondary margin-top-5"
						onClick={() => showMoreRows()}
					>
						{intl('Show more')}
					</button>
				)}
			</p>
		</div>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-offers/components/table/main.js